import { takeLatest, put, all, call } from 'redux-saga/effects';
import { AxiosCall } from "../../../utils/axios";
import * as actions from './actions';

function* fetchCultivationTips() {
    try {
        const result = yield call(AxiosCall, '/dashboard/cultivation-tips/');
        yield put(actions.fetchCultivationTipsSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchCultivationTipsFailure(e));
    }
}

export default function* cultivationTipsSaga() {
    yield all([
        // Watchers
        takeLatest(actions.FETCH_CULTIVATION_TIPS.REQUEST, fetchCultivationTips),
    ])
}
